<template>
  <div>
    <h3 class="text-bold">
      Update {{ employee.first_name }} {{ employee.last_name }}
    </h3>

    <div class="alert alert-danger mt-20" v-if="Object.keys(errors).length">
      <h4 class="semi-bold text-danger">
        <span class="fa fa-exclamation-triangle"></span> Sorry, there were some
        errors!
      </h4>
      <p class="text-danger">
        Please check the form, correct the issues and try again.
      </p>
    </div>

    <div class="row margin-top-20">
      <div class="col-md-9">
        <div class="grid bg-white">
          <div class="grid-title">
            <h4 class="text-bold">Employee Base Details</h4>
          </div>
          <div class="grid-body">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Name</label>
              <div class="col-sm-5">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.first_name"
                  placeholder="First Name"
                />
                <small v-if="errors.first_name" class="form-text text-danger">
                  {{ errors.first_name.join(" ") }}
                </small>
              </div>
              <div class="col-sm-5">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.last_name"
                  placeholder="Last Name"
                />
                <small v-if="errors.last_name" class="form-text text-danger">
                  {{ errors.last_name.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Nickname</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.nickname"
                  placeholder="Nickname"
                />
                <small v-if="errors.nickname" class="form-text text-danger">
                  {{ errors.nickname.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Department</label>
              <div class="col-sm-10">
                <v-select
                  placeholder="Choose One"
                  @input="setDepartmentSelected"
                  v-model="employee.department"
                  :options="pageData.departments"
                />
                <small v-if="errors.department" class="form-text text-danger">
                  {{ errors.department.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Position</label>
              <div class="col-sm-10">
                <v-select
                  placeholder="Choose One"
                  v-model="employee.position_id"
                  label="name"
                  :reduce="(position) => position.id"
                  :options="pageData.positions_filtered"
                />
                <small v-if="errors.position" class="form-text text-danger">
                  {{ errors.position_id.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Start / End Dates</label>
              <div class="col-sm-5">
                <input
                  type="date"
                  class="form-control"
                  v-model="employee.befeni_start"
                  placeholder="Start Date"
                />
                <small v-if="errors.befeni_start" class="form-text text-danger">
                  {{ errors.befeni_start.join(" ") }}
                </small>
              </div>
              <div class="col-sm-5">
                <input
                  type="date"
                  class="form-control"
                  v-model="employee.befeni_end"
                  placeholder="End Date"
                />
                <small v-if="errors.befeni_end" class="form-text text-danger">
                  {{ errors.befeni_end.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Birth City</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.birth_city"
                  placeholder="Birth City"
                />
                <small v-if="errors.birth_city" class="form-text text-danger">
                  {{ errors.birth_city.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Marital Status</label>
              <div class="col-sm-10">
                <v-select
                  placeholder="Choose One"
                  v-model="employee.marital_status"
                  :options="pageData.marital_status"
                />
                <small
                  v-if="errors.marital_status"
                  class="form-text text-danger"
                >
                  {{ errors.marital_status.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">children</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.children"
                  placeholder="Children"
                />
                <small v-if="errors.children" class="form-text text-danger">
                  {{ errors.children.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Hobby #1</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.hobby1"
                  placeholder="Hobby #1"
                />
                <small v-if="errors.hobby1" class="form-text text-danger">
                  {{ errors.hobby1.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Hobby #2</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.hobby2"
                  placeholder="Hobby #2"
                />
                <small v-if="errors.hobby2" class="form-text text-danger">
                  {{ errors.hobby2.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Favorite Food</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.favorite_food"
                  placeholder="Favorite Food"
                />
                <small
                  v-if="errors.favorite_food"
                  class="form-text text-danger"
                >
                  {{ errors.favorite_food.join(" ") }}
                </small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Favorite Fabric</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="employee.favorite_fabric"
                  placeholder="Favorite Fabric"
                />
                <small
                  v-if="errors.favorite_fabric"
                  class="form-text text-danger"
                >
                  {{ errors.favorite_fabric.join(" ") }}
                </small>
              </div>
            </div>

            <button
              class="btn-primary btn-large btn btn-block"
              @click="updateEmployee()"
              v-if="!isReadOnlyUser"
            >
              Update Employee
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-3" v-if="!isReadOnlyUser">
        <div class="col-md-12 text-center file-upload-panel-container">
          <div class="file-upload-element" @click="showNativeUploadDialog()">
            <div
              href="file-upload-placeholder"
              v-if="uploadComponent.displayUploadPlaceholder"
            >
              <i class="fa fa-cloud-upload" aria-hidden="true"></i>
              <span>Click Here To Select Picture</span>
            </div>
            <img
              src=""
              class="file-upload-preview"
              v-show="uploadComponent.displayPreviewImage"
              ref="file-upload-preview"
            />
          </div>
          <input
            type="file"
            name="image_url"
            id="file-upload-input"
            @change="loadChosenFile($event)"
            ref="file-upload-input"
          />
          <small v-if="error" class="form-text text-danger">{{
            error.join(" ")
          }}</small>
        </div>

        <button
          class="btn-primary btn-large btn btn-block"
          :class="{
            disabled:
              uploadComponent.imageButtonProcessing ||
              uploadComponent.picture == employee.picture,
          }"
          @click="updatePicture()"
        >
          Update Picture
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import vSelect from "vue-select";
import vueCountryRegionSelect from "vue-country-region-select";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      errors: {},
      isReadOnlyUser: false,
      pageData: {
        departments: [],
        positions: [],
        positions_filtered: [],
        marital_status: [],
      },
      employee: {
        first_name: null,
        last_name: null,
        nickname: null,
        department: null,
        position_id: null,
        befeni_start: null,
        befeni_end: null,
        birth_city: null,
        marital_status: null,
        children: null,
        hobby1: null,
        hobby2: null,
        favorite_food: null,
        favorite_fabric: null,
      },
      uploadComponent: {
        imageButtonProcessing: false,
        picture: null,
        displayUploadPlaceholder: true,
        displayPreviewImage: false,
      },
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    let employeeId = this.$route.params.id;
    this.loadEmployee(employeeId);
  },
  methods: {
    async loadEmployee(supplierId) {
      let results = await axios({
        method: "get",
        url: "/v2/performance_scanning/employees/" + supplierId + "/edit",
      });
      this.employee = results.data.data.employee;
      this.pageData.departments = results.data.data.departments;
      this.pageData.positions = results.data.data.positions;
      this.pageData.marital_status = results.data.data.marital_status;
      this.pageData.positions_filtered = this.pageData.positions;

      if (this.employee.picture !== null) {
        this.loadProvidedImage(this.employee.picture);
      }
    },

    setDepartmentSelected(selectedDepartment) {
      this.pageData.positions_filtered = this.pageData.positions.filter(
        (position) => position.department == selectedDepartment
      );
    },

    loadProvidedImage(picture) {
      this.uploadComponent.picture = picture;
      this.uploadComponent.displayUploadPlaceholder = false;
      this.uploadComponent.displayPreviewImage = true;
      this.$refs["file-upload-preview"].src = picture;
    },

    showNativeUploadDialog() {
      let elem = this.$refs["file-upload-input"];
      elem.click();
    },

    loadChosenFile(event) {
      console.log(event);
      let self = this;
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = function (e) {
          self.uploadComponent.displayUploadPlaceholder = false;
          self.uploadComponent.displayPreviewImage = true;
          self.$refs["file-upload-preview"].src = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
        this.uploadComponent.picture = input.files[0];
      }
    },

    async updateEmployee() {
      try {
        let employeeId = this.$route.params.id;
        this.errors = {};
        let results = await axios({
          method: "put",
          url: "/v2/performance_scanning/employees/" + employeeId,
          data: this.employee,
        });
        toastr.success("Employee successfully updated.");
      } catch (error) {
        this.errors = error.response.data.errors;
        window.scrollTo(0, 0);
      }
    },

    async updatePicture() {
      let formData = new FormData();
      formData.append("image", this.uploadComponent.picture);
      try {
        this.uploadComponent.imageButtonProcessing = true;
        let employeeId = this.$route.params.id;
        let result = await axios.post(
          "/v2/performance_scanning/employees/" + employeeId + "/image",
          formData
        );
        if (result.data.status) {
          this.uploadComponent.picture = this.employee.picture =
            result.data.data;
          toastr.success("Picture successfully updated");
        }
        this.uploadComponent.imageButtonProcessing = false;
      } catch (error) {
        this.uploadComponent.imageButtonProcessing = false;
        toastr.error("Error uploading picture!");
      }
    },
  },
};
</script>

<style scoped>
@import "~sweetalert2/dist/sweetalert2.min.css";
@import "~vue-select/dist/vue-select.css";

.col-form-label {
  margin-top: 10px;
}

.file-upload-panel-container {
  padding-top: 0px !important;
  padding-left: 0px;
  padding-right: 0px;
  margin-bottom: 20px;
}

.file-upload-panel-container .file-upload-element {
  text-align: center;
  border-radius: 10px;
  background: #eee;
  border: 3px dashed #ccc !important;
  min-height: 322px;
  max-height: 332px;
  width: 322px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.file-upload-panel-container .file-upload-element:hover {
  border: 3px dashed #aaa !important;
}

.file-upload-panel-container .file-upload-element i {
  font-size: 80px;
  display: block;
}

.file-upload-panel-container #file-upload-input {
  display: none;
}

.file-upload-panel-container button {
  margin-top: 10px;
  cursor: pointer;
}

.file-upload-panel-container .file-upload-preview {
  width: 308px;
  max-height: 308px;
  border-radius: 10px;
}
</style>
